/* SPC — slide-out cart. Opens on the page the shopper is on, so adding,
   changing sizes and checking out never means leaving and coming back.
   Public: window.SPCCart.open(), .refresh(), .close() */
(function () {
  'use strict';
  var root = document.querySelector('[data-cd]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-cd-config]').textContent); } catch (e) {}
  var FREE = cfg.freeShipping || 4000;
  var SHIP = cfg.shippingRate || 0;
  var moneyFormat = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var panel = root.querySelector('.cd__panel');
  var listEl = root.querySelector('[data-cd-items]');
  var emptyEl = root.querySelector('[data-cd-empty]');
  var footEl = root.querySelector('[data-cd-foot]');
  var shipEl = root.querySelector('[data-cd-ship]');
  var upsellEl = root.querySelector('[data-cd-upsell]');
  var toastEl = root.querySelector('[data-cd-toast]');
  var countEl = root.querySelector('[data-cd-count]');
  var cart = cfg.cart || null;
  /* Texts come from the locale file via window.SPC_T (layout/theme.liquid) */
  var T = window.SPC_T || {};
  function tr(k, d) { return T[k] || d; }
  var lastFocus = null;
  var busy = false;

  /* ---------- helpers ---------- */
  function fmt(n, dec, th, ds) {
    var s = (n / 100).toFixed(dec), p = s.split('.');
    var w = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return dec ? w + ds + p[1] : w;
  }
  function money(c) {
    c = Math.round(c);
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(c, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(c, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(c, 0, '.', ',');
      return fmt(c, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function api(url, body) {
    var opts = { headers: { 'Accept': 'application/json' } };
    if (body) {
      opts.method = 'POST';
      if (body instanceof FormData) { opts.body = body; }
      else { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    }
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || tr('error', 'Something went wrong'));
        return j;
      });
    });
  }
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toast.t);
    toast.t = setTimeout(function () { toastEl.hidden = true; }, 4000);
  }

  /* ---------- header badge ---------- */
  function badge(n) {
    document.querySelectorAll('.hdr a[href$="/cart"]').forEach(function (a) {
      var b = a.querySelector('.hdr__count');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('span'); b.className = 'hdr__count'; a.style.position = 'relative'; a.appendChild(b); }
      b.textContent = n;
    });
    if (countEl) countEl.textContent = n ? '(' + n + ')' : '';
  }

  /* ---------- render ---------- */
  function renderShip(total) {
    if (!shipEl) return;
    var left = FREE - total;
    var pct = Math.max(4, Math.min(100, Math.round(total / FREE * 100)));
    shipEl.classList.toggle('is-done', left <= 0);
    shipEl.innerHTML =
      '<p>' + (left <= 0
        ? tr('free_unlocked_html', '<b>Free shipping unlocked.</b>')
        : tr('free_away_html', '<b>__AMT__</b> away from <b>free shipping</b>').replace('__AMT__', money(left))) + '</p>' +
      '<div class="cd__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><span style="width:' + pct + '%"></span></div>';
  }

  function lineHTML(it) {
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
    var props = '';
    if (it.properties) {
      Object.keys(it.properties).forEach(function (k) {
        var v = it.properties[k];
        if (k.charAt(0) === '_' || v === '' || v == null) return;
        props += '<li>' + esc(k) + ': ' + esc(v) + '</li>';
      });
    }
    var discounts = (it.line_level_discount_allocations || []).map(function (d) {
      return '<li class="cd__deal">' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</li>';
    }).join('');
    var was = it.original_line_price > it.final_line_price
      ? '<s>' + money(it.original_line_price) + '</s>' : '';
    var pic = it.featured_image && it.featured_image.url ? img(it.featured_image.url, 200) : '';
    return '<li class="cd__line" data-key="' + esc(it.key) + '">' +
      '<a class="cd__pic" href="' + esc(it.url) + '">' + (pic ? '<img src="' + esc(pic) + '" alt="" width="88" height="110" loading="lazy">' : '') + '</a>' +
      '<div class="cd__info">' +
        '<a class="cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant ? '<p class="cd__var">' + esc(variant) + '</p>' : '') +
        (props || discounts ? '<ul class="cd__props">' + props + discounts + '</ul>' : '') +
        '<div class="cd__row">' +
          '<div class="cd__qty" aria-label="' + esc(tr('quantity', 'Quantity')) + '">' +
            '<button type="button" data-cd-qty="-1" aria-label="' + esc(tr('one_less', 'One less')) + '">−</button>' +
            '<span aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-cd-qty="1" aria-label="' + esc(tr('one_more', 'One more')) + '">+</button>' +
          '</div>' +
          '<div class="cd__price">' + was + '<b>' + money(it.final_line_price) + '</b></div>' +
        '</div>' +
        '<button type="button" class="cd__rm" data-cd-remove>' + esc(tr('remove', 'Remove')) + '</button>' +
      '</div>' +
    '</li>';
  }

  function render() {
    if (!cart) return;
    var n = cart.item_count;
    badge(n);
    var empty = !n;
    emptyEl.hidden = !empty;
    footEl.hidden = empty;
    listEl.innerHTML = cart.items.map(lineHTML).join('');
    renderShip(cart.total_price);

    var saved = cart.total_discount || 0;
    root.querySelector('[data-cd-sub]').textContent = money(cart.items_subtotal_price);
    var saveRow = root.querySelector('[data-cd-save-row]');
    saveRow.hidden = !saved;
    root.querySelector('[data-cd-save]').textContent = '−' + money(saved);
    /* Shipping shown before checkout, so the total there is no surprise */
    var ship = !cart.requires_shipping || cart.total_price >= FREE ? 0 : SHIP;
    var shipOut = root.querySelector('[data-cd-shipcost]');
    if (shipOut) shipOut.innerHTML = !cart.requires_shipping ? '—' : (ship ? money(ship) + ' <small>' + esc(tr('free_over', 'free over __AMT__').replace('__AMT__', money(FREE))) + '</small>' : '<b class="cd__saved">' + esc(tr('free', 'Free')) + '</b>');
    root.querySelector('[data-cd-total]').textContent = money(cart.total_price + ship);
    root.querySelector('[data-cd-checkout-total]').textContent = money(cart.total_price + ship);
    loadUpsell();
  }

  /* ---------- "complete the look": one-tap add, no page change ---------- */
  var upsellFor = null;
  function loadUpsell() {
    if (!upsellEl) return;
    if (!cart || !cart.items.length) { upsellEl.hidden = true; upsellFor = null; return; }
    var pid = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) { return i.product_id; });
    if (upsellFor === pid + ':' + inCart.join(',')) return;
    upsellFor = pid + ':' + inCart.join(',');
    /* Curated picks first (the current season's pieces, set in the snippet);
       Shopify's own recommendations only if all of those are already in the cart. */
    var curated = (cfg.upsell || []).filter(function (p) { return inCart.indexOf(p.id) < 0; });
    var source = curated.length
      ? Promise.resolve({ products: curated })
      : fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related').then(function (r) { return r.json(); });
    source
      .then(function (j) {
        var picks = (j.products || []).filter(function (p) {
          return p.available && inCart.indexOf(p.id) < 0 && p.variants.some(function (v) { return v.available; });
        }).slice(0, 2);
        if (!picks.length) { upsellEl.hidden = true; return; }
        upsellEl.hidden = false;
        upsellEl.querySelector('[data-cd-upsell-list]').innerHTML = picks.map(function (p) {
          var vs = p.variants.filter(function (v) { return v.available; });
          var select = vs.length > 1
            ? '<select data-cd-upsell-variant aria-label="' + esc(tr('choose_option', 'Choose an option')) + '">' + vs.map(function (v) {
                return '<option value="' + v.id + '">' + esc(v.title) + '</option>';
              }).join('') + '</select>'
            : '<input type="hidden" data-cd-upsell-variant value="' + vs[0].id + '">';
          var pic = p.featured_image ? img(p.featured_image, 160) : '';
          return '<li class="cd__up">' +
            '<a class="cd__up-pic" href="' + esc(p.url) + '">' + (pic ? '<img src="' + esc(pic) + '" alt="" width="64" height="80" loading="lazy">' : '') + '</a>' +
            '<div class="cd__up-info"><a href="' + esc(p.url) + '">' + esc(p.title.split(' — ')[0]) + '</a>' +
              '<span>' + money(p.price) + '</span>' + select + '</div>' +
            '<button type="button" class="cd__up-add" data-cd-upsell-add aria-label="' + esc(tr('add', 'Add') + ' ' + p.title) + '">' + esc(tr('add', 'Add')) + '</button>' +
          '</li>';
        }).join('');
      })
      .catch(function () { upsellEl.hidden = true; });
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root.hidden && root.classList.contains('is-on')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('cd-lock');
    requestAnimationFrame(function () {
      root.classList.add('is-on');
      var x = root.querySelector('[data-cd-close]');
      if (x) x.focus({ preventScroll: true });
    });
  }
  function close() {
    root.classList.remove('is-on');
    document.documentElement.classList.remove('cd-lock');
    setTimeout(function () { root.hidden = true; }, reduce ? 0 : 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function refresh() {
    return api('/cart.js').then(function (c) { cart = c; render(); return c; });
  }

  root.querySelectorAll('[data-cd-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-on')) close();
    if (e.key === 'Tab' && root.classList.contains('is-on')) {
      var f = panel.querySelectorAll('a[href], button:not([disabled]), select, input:not([type=hidden]), textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- line changes, without reloading ---------- */
  function change(key, qty, lineEl) {
    if (busy) return;
    busy = true;
    if (lineEl) lineEl.classList.add('is-busy');
    api('/cart/change.js', { id: key, quantity: qty })
      .then(function (c) { cart = c; render(); })
      .catch(function (e) { toast(e.message); refresh(); })
      .then(function () { busy = false; });
  }

  root.addEventListener('click', function (e) {
    var line = e.target.closest('.cd__line');
    var q = e.target.closest('[data-cd-qty]');
    if (q && line) {
      var it = cart.items.filter(function (i) { return i.key === line.dataset.key; })[0];
      if (it) change(it.key, Math.max(0, it.quantity + parseInt(q.dataset.cdQty, 10)), line);
      return;
    }
    if (e.target.closest('[data-cd-remove]') && line) { change(line.dataset.key, 0, line); return; }

    var add = e.target.closest('[data-cd-upsell-add]');
    if (add) {
      var box = add.closest('.cd__up');
      var vid = box.querySelector('[data-cd-upsell-variant]').value;
      add.disabled = true; add.textContent = '…';
      api('/cart/add.js', { items: [{ id: parseInt(vid, 10), quantity: 1 }] })
        .then(refresh)
        .catch(function (err) { toast(err.message); add.disabled = false; add.textContent = tr('add', 'Add'); });
    }
  });

  /* ---------- every add-to-cart form on the site opens the drawer ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') < 0) return;
    if (form.hasAttribute('data-cd-native')) return;
    /* The harness form builds its own multi-item add (patch names, guide) and
       calls SPCCart.open() itself when done. */
    if (form.querySelector('[data-hp-tier-body]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = e.submitter || form.querySelector('[type=submit]');
    var label = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.classList.add('is-adding'); }

    api('/cart/add.js', new FormData(form))
      .then(refresh)
      .then(open)
      .catch(function (err) { open(); toast(err.message); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-adding'); btn.innerHTML = label; } });
  }, true);

  /* ---------- cart icon / cart links open the drawer instead of a new page ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], [data-cart-open]');
    if (!a || root.contains(a)) return;
    if (/\/cart\/?$/.test(location.pathname)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var menu = document.querySelector('[data-menu]');
    if (menu && !menu.hidden) { var x = menu.querySelector('[data-menu-close]'); if (x) x.click(); }
    open();
    refresh();
  });

  /* Back/forward cache: the cart may have changed in another tab or at checkout */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  window.SPCCart = { open: function (fetchFirst) { if (fetchFirst) { refresh().then(open); } else { open(); } }, close: close, refresh: refresh };
  try { render(); } catch (e) { refresh(); }
})();